import { T } from '@territory/tokens';
import { duration, space, TOUCH_MIN } from '../scale.js';

/* Exact BackToTop blur, shadow reach and alpha() output from the public site. */
const SHADOW_REACH = 30;
const EASE = 'var(--rv-marketing-scroll-ease, cubic-bezier(0.16,1,0.3,1))';
export function marketingScrollCss(sel: string): string {
  const transition = ['opacity', 'transform', 'background', 'border-color', 'color', 'box-shadow']
    .map(property => `${property} ${duration.slow}ms ${EASE}`).join(', ');
  return `${sel} { width: ${TOUCH_MIN}px; height: ${TOUCH_MIN}px; cursor: pointer; background: var(--rv-marketing-scroll-fill, ${T.bgElev}); backdrop-filter: blur(${space[3]}px); -webkit-backdrop-filter: blur(${space[3]}px); border: 1px solid color-mix(in srgb, ${T.accent} 33.33%, transparent); color: ${T.accent}; display: flex; align-items: center; justify-content: center; transition: ${transition}; box-shadow: 0 ${space[3]}px ${SHADOW_REACH}px color-mix(in srgb, ${T.accent} 12.55%, transparent); }
${sel}:focus-visible { outline: 2px solid ${T.accent}; outline-offset: 3px; }`;
}
